PrintoutColGroup = ({ renderMode, withAdditionalConsiderations }) ->
  return null if renderMode isnt 'printout'
  <colgroup>
    <col className='judgement' />
    <col className='research-evidences' />
    {withAdditionalConsiderations and <col className='additional-considerations' />}
  </colgroup>

module.exports = PrintoutColGroup
